<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm"><a class="xref" href="#/wsuhavas0008#acknow" id="racknow">Acknowledgments</a></p>
<p class="tocf"><a class="xref" href="#/wsuhavas0009#intro" id="rintro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/wsuhavas0010#ch01" id="rch01"><b>1</b> Quality TV, Gender, and the Politics of Cultural Transgression</a></p>
<p class="tocpt"><a class="xref" href="#/wsuhavas0011#pt01" id="rpt01">Comedies</a></p>
<p class="toc"><a class="xref" href="#/wsuhavas0012#ch02" id="rch02"><b>2</b> The “Feminist Comedy of Distinction”: Genre and Gender in the Female-Centered Quality Sitcom</a></p>
<p class="toc"><a class="xref" href="#/wsuhavas0013#ch03" id="rch03"><b>3</b> Negotiating (Post)Feminism in Feminist Quality Comedy</a></p>
<p class="toc"><a class="xref" href="#/wsuhavas0014#ch04" id="rch04"><b>4</b> Body Politics and the Quality Comedy</a></p>
<p class="tocpt"><a class="xref" href="#/wsuhavas0015#pt02" id="rpt02">Dramas</a></p>
<p class="toc"><a class="xref" href="#/wsuhavas0016#ch05" id="rch05"><b>5</b> Cultural Status and Genre in the Female-Centered Prestige Drama</a></p>
<p class="toc"><a class="xref" href="#/wsuhavas0017#ch06" id="rch06"><b>6</b> Female-Centered Prestige Drama and (Post)Feminism</a></p>
<p class="tocf"><a class="xref" href="#/wsuhavas0018#conc" id="rconc">Conclusion</a></p>
<p class="tocbmf"><a class="xref" href="#/wsuhavas0019#biblio" id="rbiblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/wsuhavas0020#ch07" id="rch07">List of Television Programs and Films</a></p>
<p class="tocbm"><a class="xref" href="#/wsuhavas0021#index" id="rindex">Index</a></p>
<p class="tocbm"><a class="xref" href="#/wsuhavas0022#aubio" id="raubio">About the Author</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-havas-0007.vue?2003fafc